import React from "react";
import ValueFiltersPanel from "views/marketplace/merchandising/filter/valueFiltersPanel";

// The Sales tab's single free numeric input: minimum online sales count.
export const SALES_FILTER_ITEMS = [
    {"@type": "SalesMin", id: "salesMin", unit: "", labelId: "merchandising.show.label.filters.sales.min"},
];

export default function SalesFilterPanel() {
    return <ValueFiltersPanel items={SALES_FILTER_ITEMS} applyLabelId={"merchandising.show.label.filters.sales.apply"}/>;
}
